export default {
    newDesign: true,
    parameters: {
        landing_id: "TrLQFwd",
        segment: 11,
        success_page: 'success_long'
    },
    title: "Çocuğunuz evden programlama öğrensin – eğlenceli ve kolay! | Kodland",
    downtimeUrl: "https://www.kodland.org/tr",
    startPage: {
        title:
            "İlk deneme dersinize kaydolmak için soruları cevaplayın.",
        subtitle:
            "Çizim tutkusunu avantaja dönüştürüyoruz:<br>💬 Çocuğunuzun yeteneklerini eğlenceli bir şekilde keşfedin<br>🌐 Sadece bir bilgisayar ve internet bağlantısına ihtiyacınız var<br>💙 Sadece bugün 270’den fazla çocuk kaydoldu",
        image: {
            url: "/welcome/tr_longquiz_fwd_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/tr_longquiz_fwd_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "Haydi başlayalım! 🔥",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
        subtitle:
            "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
    },
    quizRotateBySteps: {
        1: {
            title: "Çocuğunuz kaç yaşında?",
            type: "age",
            button: "",
        },
        2: {
            question: "Çocuğunuz boş zamanlarında en çok ne yapmayı sever?",
            answers: [
                "Spor yapmak veya açık havada oyunlar ⚽",
                "Kitap veya çizgi roman okumak 📚",
                "Televizyon izlemek, YouTube veya video oyunları 🎮",
                "Çiz, boya ya da el işi yap 🎨✏️",
                "Arkadaşlarıyla veya ailesiyle vakit geçirmek 👫",
                "Diğer 🙂"
            ],
        },
        3: {
            question: "Çocuğunuz çevrim içi öğrenme hakkında ne düşünüyor?",
            answers: [
                "Seviyor ve ilginç buluyor 💻",
                "Yüz yüze öğrenmeyi tercih ediyor 🙂",
                "Dikkatini toplamakta zorlanıyor 😬",
                "Hiç denemedi ❓"
            ],
        },
        4: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/tr_screen_time.png",
            subtitle: "Çocukların günde 2 saatten fazla ekran karşısında vakit geçirmemeleri tavsiye edilse de, gerçekte bu süre genellikle daha fazladır. Bu nedenle, eğlenceyi 1–1,5 saat süren dersler gibi verimli aktivitelerle dengelemek idealdir.",
            button: "Harika ✅",
        },
        5: {
            question: "Okulda çocuğunuz en çok hangi dersleri sever?",
            answers: [
                "Fen veya matematik 🧪🔢",
                "Hikâye okumak ve yazmak 📚✍️",
                "Sanat, müzik veya yaratıcı etkinlikler 🎨🎶",
                "Beden eğitimi veya spor 🏃‍♂️⚽",
                "Diğer 🙂"
            ],
        },
        6: {
            question: "Çocuğunuz bir şeyler inşa etmeyi veya tasarlamayı seviyor mu? (ör. Lego, sanat, bulmaca)",
            answers: [
                "Evet, inşa etmeyi ve tasarlamayı çok seviyor 🌿🏗️",
                "Bazen, ama başka etkinlikleri daha çok seviyor 🤔",
                "Hayır, çok ilgilenmiyor 🙇"
            ],
        },
        7: {
            question: "Çocuğunuz yeni şeyleri en iyi nasıl öğreniyor veya hatırlıyor?",
            answers: [
                "Görerek (görsel öğrenme) 👁️",
                "Yaparak (uygulamalı öğrenme) ✋",
                "Dinleyerek (işitsel öğrenme) 🎧",
                "Tekrar ve pratik yoluyla ✏️"
            ],
        },
        8: {
            question: "Ücretsiz derse katılmak için çocuğunuzun bilgisayar veya dizüstü bilgisayar (telefon değil) ve sabit internet bağlantısı olması gerekir. Evinizde bilgisayar/dizüstü bilgisayar var mı?",
            answers: [
                "💻 Evet, evimizde var",
                {
                    answer: "❌ Hayır, evimizde yok",
                    stopAnswer: true,
                }
            ],
        },
        9: {
            question: "Çocuğunuzun en çok ilgisini hangi aktiviteler veya hobiler çeker?",
            answers: [
                "Spor veya dans ⚽",
                "Yaratıcı sanatlar 🎨✏️",
                "Resim, boyama veya el işleri 🍀♟️🖥️",
                "Video oyunları veya video izleme 🎮🖥️",
                "Diğer 🙂"
            ],
        },
        10: {
            question: "Çocuğunuz bir grup içinde çalışırken nasıl davranır?",
            answers: [
                "İş birliği yapmayı sever 🤝💡",
                "Liderlik etmeyi tercih eder 🧑‍🏫",
                "Bağımsız çalışır ama katkı sağlar 🧍‍♂️✔️",
                "Çekingen veya rahatsız hisseder 😳"
            ],
        },
        11: {
            question: "Çocuğunuz grup çalışmalarında genellikle hangi rolü üstlenir?",
            answers: [
                "Liderlik etmeyi ve düzenlemeyi sever 🧑‍🏫📋",
                "Fikir üretmeyi ve iş birliği yapmayı sever 🤝💡",
                "Dinlemeyi ve takip etmeyi tercih eder 👂🙂",
                "Arabuluculuk yapmaya veya sorun çözmeye çalışır ⚖️🕊️",
                "Çekingen olur ve geri planda kalır 😳"
            ],
        },
        12: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/tr_laptop.png",
            subtitle: "Bireysel ve grup öğrenme formatları sunuyoruz, süreci her çocuğun yaşına göre uyarlıyoruz, böylece mümkün olduğunca kişiselleştirilmiş oluyor.",
            button: "Haydi başlayalım!",
        },
        13: {
            question: "Çocuğunuz programlama öğrenmeye ilgi gösterdi mi?",
            answers: [
                "Evet, öğrenmeye başladı bile 💻🚀",
                "Evet, merak ediyor ama denemedi 🤔💡",
                "Henüz değil, ama belki ilgilenir 🧑‍🎓",
                "Hayır, ilgilenmiyor 🙅"
            ],
        },
        14: {
            question: "Çocuğunuz ne zaman kendini daha rahat ve mutlu hissediyor?",
            answers: [
                "Arkadaşlarıyla veya ailesiyle oynarken 👫❤️",
                "Yeni şeyler keşfederken veya öğrenirken ✨🔍",
                "Bir şeyler yaratırken veya inşa ederken 🛠️✨",
                "Sessiz bir an yaşarken 🤫📖"
            ],
        },
        15: {
            question: "Çocuğunuz en çok ne yapmayı sever?",
            answers: [
                "Karakter çizmek ve tasarlamak 🎨",
                "Hikâyelerle animasyon veya çizgi roman 🎬",
                "3D kahramanlar/dünyalar yapmak 🧊",
                "Logo, site veya çıkartma tasarımı 🖌️",
                "Hepsini seviyor, tam emin değilim 🤔"
            ],
        },
        16: {
            question: "Çocuğunuz bir şeyler yaratmayı veya arkadaşlarıyla etkinlikler yapmayı sever mi?",
            answers: [
                "Evet, grup içinde yaratıcı projeleri sever 👫🎨",
                "Bazen, aktiviteye bağlı 🤔",
                "Hayır, bireysel görevleri tercih eder 🧍💡"
            ],
        },
        17: {
            question: "Çocuğunuz teknoloji kullanırken (bilgisayar, uygulama veya temel internet görevleri) kendini rahat hissediyor mu?",
            answers: [
                "Çok rahat, sık sık kullanıyor 💻✅",
                "Görevleri yapıyor ama yardıma ihtiyaç duyuyor 🖱️❓",
                "Alışkın değil 🚫"
            ],
        },
        18: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/tr_before_after.png",
            subtitle: "Kodland’da öğrenciler 3D modeller tasarlar, çizgi romanlar oluşturur, oyunlar geliştirir ve programlama öğrenir. Şu anda dünya genelinde 30.000’den fazla çocuk bizimle öğreniyor!",
            button: "Harika ✅",
        },
        19: {
            question: "Çocuğunuz zorluklar veya problemlerle nasıl başa çıkıyor?",
            answers: [
                "Kendi başına çözmeye çalışır 💪🧠",
                "Gerekirse yardım ister 🙋‍♀️✔️",
                "Kolayca hayal kırıklığına uğrar ve pes eder 😣",
                "Sorunları bir meydan okuma olarak görür 🧑‍🏫"
            ],
        },
        20: {
            question: "Çocuğunuz en çok ne yaratmaktan hoşlanıyor?",
            answers: [
                "Benzersiz karakterler ve görünümleri 🦸‍♂️",
                "Karakterlerin yaşayacağı dünyalar 🗺️",
                "Heyecanlı hikâyeler ve senaryolar 📜",
                "Logolar veya afiş gibi görsel tasarımlar ✨",
                "Mevcut fikirleri hayata geçirmeyi tercih ediyorlar ✍️"
            ],
        },
        21: {
            question: "Çocuğunuz dikkat ve mantıksal düşünme gerektiren görevleri nasıl yapıyor?",
            answers: [
                "Odaklanıyor ve problemleri çözüyor 🎯🍀",
                "Yönlendirme ile iyi performans gösteriyor 📋🤝",
                "Detaylı görevlerde zorlanıyor 😅"
            ],
        },
        22: {
            question: "Çocuğunuz bir hikâye anlattığında genellikle…",
            answers: [
                "Detaylara odaklanır 🧵📜",
                "Direkt ana fikre gider 🎯",
                "Mizah veya hayal gücü ekler 🤹✨",
                "Düşüncelerini organize etmekte zorlanır 🤔"
            ],
        },
        23: {
            question: "Çocuğunuz yeni bir şey denerken nasıl tepki verir?",
            answers: [
                "Hevesle başlar 🎉🚀",
                "Meraklıdır ama temkinlidir 🤔👣",
                "Gergin hisseder ve desteğe ihtiyaç duyar 😬🙋",
                "Deney yapmayı sever 🛠️🧪",
                "Yeni şeyleri denemeye direnç gösterir 🙅"
            ],
        },
        24: {
            question: "Çocuğunuz talimatları izlemeyi mi yoksa kendi fikirlerini üretmeyi mi tercih eder?",
            answers: [
                "Açık talimatları sever ✔️",
                "Yaratıcı fikirleri ve yeni yaklaşımları tercih eder 🎨",
                "Hem yapı hem özgürlüğü sever 🛠️",
                "Göreve bağlı: yapı veya yaratıcılık 🤷‍♂️"
            ],
        },
        25: {
            typeInfo: "noQuestions",
            imageLink: "/welcome/tr_reviews.png",
            subtitle: "Dünyanın dört bir yanındaki aileler bizi tavsiye ediyor. Umarız siz de yakında onlara katılırsınız! 💙",
            button: "Neredeyse bitti! ✅",
        },
        26: {
            question: "Çocuğunuzun bir göreve odaklanmasını ne motive eder?",
            answers: [
                "Sonda net bir hedef veya ödül 🎯🏅",
                "Göreve duyulan heyecan veya tutku ✨❤️",
                "Bir grup içinde çalışmak 🤝💬",
                "Süreç boyunca motivasyon almak 👏🙂",
                "Bir meydan okuma veya yarışma hissi 🏅🔥"
            ],
        },
        27: {
            question: "Çocuğunuzun konuşmayı en çok sevdiği hikâye veya konular neler?",
            answers: [
                "Bilim, teknoloji veya icatlar 🧪🛠️",
                "Komik veya eğlenceli hikâyeler 🤪😂",
                "Gerçek olaylar veya tarih 📜🌍",
                "Arkadaşlıklar veya duygularla ilgili hikâyeler ❤️👫"
            ],
        },
        28: {
            question: "Çocuğunuzu en çok ne gururlandırır veya mutlu eder?",
            answers: [
                "Zor bir görevi tamamlamak 🏆🧠",
                "Başkalarına yardım etmek veya katkıda bulunmak 🤝❤️",
                "Yeni bir şey öğrenmek 📚✨",
                "Olumlu geri bildirim almak 🥳👏",
                "Karmaşık bir problemi çözmek 🔍🍀"
            ],
        },
        29: {
            title: "🎉 Sadece bir adım kaldı!",
            typeInfo: "congrats",
            subtitle:
                "Çocuğunuza programlama ve dijital tasarım ile yaratıcı yönünü keşfetmesine yardımcı olun.<br>🌟 200.000’den fazla çocuk bizimle öğreniyor ve üretiyor.",
            button: "📅 Ücretsiz dersinizi ayırtın!",
        },
        30: {
            title: "🎉 Ücretsiz deneme dersine kaydolun",
            type: "one-page-contacts",
            subtitle: "Çocuğunuz ilk derste bir tasarım projesi oluşturacak. Siz de katılabilirsiniz!",
            button: "✨ Harika! Sadece bir adım kaldı.",
        },
        31: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        32: {
            title: "Kaydı tamamlamak için bu bilgileri inceleyin ✨",
            typeInfo: "pc-laptop",
            subtitle:
                "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
            button: "Başka neler var?",
        },
        33: {
            title:
                "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
            button: "Başka neler var?",
        },
        34: {
            title: "Ders platformumuzda gerçekleşecek 💻",
            typeInfo: "classroom",
            subtitle:
              "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
            button: "Anladım ✅",
        },
    },
};

